import MComponent from '../Toolkit/Components/Component';
import {withMsal, WithMsalProps} from '@azure/msal-react';
import WithRouterProps from '../Toolkit/WithRouterProps';
import WithRouter from '../Toolkit/WithRouter';
import React, {createRef, ReactElement, RefObject} from 'react';
import {EditNoticeValidator, NoticeDetail, NoticeDetailListReply, NoticeHeader, NoticeHeaderReply, NoticeReply, NoticeReplyMulti} from '../Api/NoticeTypes';
import * as Yup from 'yup';
import MPage, {MPageProps} from '../Toolkit/Components/Shell/Page';
import MToolbar from '../Toolkit/Components/Controls/Toolbar';
import MButton from '../Toolkit/Components/Controls/Button';
import {MCloseIconName, MSaveIconName} from '../Toolkit/Icons';
import MSpacer from '../Toolkit/Components/Controls/Spacer';
import EnumContext from '../Context/enum-context';
import MForm, {MFormOutcome} from '../Toolkit/Components/Controls/Form';
import {FieldProps, FormikHelpers} from 'formik';
import {toErrorMessage} from '../Toolkit/Utils';
import MFormFieldControl from '../Toolkit/Components/Controls/FormFieldControl';
import MTextBox from '../Toolkit/Components/Controls/TextBox';
import MDropDown from '../Toolkit/Components/Controls/DropDown';
import MCalendar from '../Toolkit/Components/Controls/Calendar';
import {MDropDownItem} from '../Toolkit/Components/Controls/DropDownOption';
import NSwagAdapter from '../Toolkit/Api/NSwagAdapter';
import {NoticeClient, NoticeUpdateHeaderDto} from '../Api/NoticeClients';
import MNSwagClientConfiguration from '../Toolkit/Api/NSwagClientConfiguration';
import SafeDigAccessTokenProvider from '../Api/SafeDigAccessTokenProvider';
import {Roles} from '../Roles';
import {Divider} from 'primereact/divider';
import MFormSection from '../Toolkit/Components/Controls/FormSection';
import {SafeDigClient, SafeDigSendRequest} from '../Api/SafeDigsClients';
import {ChangeFileStateRequest, SafeDigFileClient} from '../Api/SafeDigFilesClients';
import {UpdateSafeDigFileReply} from '../Api/SafeDigFileTypes';
import NoticeFileDialog from './Dialogs/NoticeFileDialog';
import FileStatusDialog, {FileStatusResult} from './Dialogs/FileStatusDialog';
import {ProjectReply, UpdateSafeDigReply} from '../Api/SafeDigTypes';
import AuditListControl from './Components/AuditListControl';
import {AuditLog, AuditLogListReply} from '../Api/AuditTypes';
import {AuditLogClient} from '../Api/AuditLogClients';
import {GotoIconName, SendIconName} from './SafeDigConstants';
import JobSendDialog from './Dialogs/JobSendDialog';
import {ContactClient} from '../Api/ContactClients';
import FormSection from '../Toolkit/Components/Controls/FormSection';
import SubNoticeControl from './Components/SubNoticeControl';
import NoticeDetailListControl from './Components/NoticeDetailListControl';
import {ContactReply} from '../Api/ContactTypes';

type RouteParams = {
    id: string;
};

type Props =  WithMsalProps & WithRouterProps<RouteParams> & {};

type AuditLogRow = {
    data: AuditLog;
}

type State = {
    page: MPageProps;
    pageTitle: string;
    pageSubTitle: string;
    form: {
        id: string;
        isSubmitting: boolean;
        notice: NoticeHeader;
        noticeDetails : NoticeDetail[];
        audit: AuditLogRow[];
        validationSchema: any;
        subNotices: NoticeReply[];
    };
    projectList: MDropDownItem<number>[];
};

class EditNoticePage extends MComponent<Props, State> {
    static contextType = EnumContext;
    context!: React.ContextType<typeof EnumContext>

    private readonly m_pageRef: RefObject<MPage>;
    private readonly m_fileUploadRef: RefObject<NoticeFileDialog>;
    private readonly m_fileStatusRef: RefObject<FileStatusDialog>;
    private readonly m_noticeClient: NSwagAdapter<NoticeClient>;
    private readonly m_fileClient: NSwagAdapter<SafeDigFileClient>;
    private readonly m_safedigClient: NSwagAdapter<SafeDigClient>;
    private readonly m_auditlogClient: NSwagAdapter<AuditLogClient>;
    private readonly m_contactClient: NSwagAdapter<ContactClient>;
    private readonly m_jobSendRef: RefObject<JobSendDialog>;

    public constructor(props: Props) {
        super(props);

        this.bindMethods();

        this.m_pageRef = createRef<MPage>();
        this.m_fileUploadRef = createRef<NoticeFileDialog>();
        this.m_fileStatusRef = createRef<FileStatusDialog>();
        this.m_jobSendRef = createRef<JobSendDialog>();
        this.m_noticeClient = new NSwagAdapter<NoticeClient>(new NoticeClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_SAFEDIGS_API_KEY!,
                new SafeDigAccessTokenProvider(this.props.msalContext))));
        this.m_fileClient = new NSwagAdapter<SafeDigFileClient>(new SafeDigFileClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_SAFEDIGS_API_KEY!,
                new SafeDigAccessTokenProvider(this.props.msalContext))));
        this.m_safedigClient = new NSwagAdapter<SafeDigClient>(new SafeDigClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_SAFEDIGS_API_KEY!,
                new SafeDigAccessTokenProvider(this.props.msalContext))));
        this.m_auditlogClient = new NSwagAdapter<AuditLogClient>(new AuditLogClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_SAFEDIGS_API_KEY!,
                new SafeDigAccessTokenProvider(this.props.msalContext))));
        this.m_contactClient = new NSwagAdapter<ContactClient>(new ContactClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_SAFEDIGS_API_KEY!,
                new SafeDigAccessTokenProvider(this.props.msalContext))));

        this.initializeState();

    }

    private bindMethods(): void {
        this.close_Click = this.close_Click.bind(this);
        this.send_Click = this.send_Click.bind(this);
        this.toSafeDig_Click = this.toSafeDig_Click.bind(this);
        this.page_onLoadData = this.page_onLoadData.bind(this);
        this.form_onBeforeSubmit = this.form_onBeforeSubmit.bind(this);
        this.form_onSubmit = this.form_onSubmit.bind(this);
        this.form_onAfterSubmit = this.form_onAfterSubmit.bind(this);
        this.form_onError = this.form_onError.bind(this);
        this.isFormDisabled = this.isFormDisabled.bind(this);
        this.isNoticingTeamMember = this.isNoticingTeamMember.bind(this);
        this.isEditDisabled = this.isEditDisabled.bind(this);
        this.isSendDisabled = this.isSendDisabled.bind(this);
        this.isPermitUpdateDisabled = this.isPermitUpdateDisabled.bind(this);
        this.isComplete = this.isComplete.bind(this);
        this.fileStatusDialog_Close = this.fileStatusDialog_Close.bind(this);
        this.subNoticeNavigate = this.subNoticeNavigate.bind(this);
        this.goto_Click = this.goto_Click.bind(this);
        this.jobSendDialog_onClose = this.jobSendDialog_onClose.bind(this);
    }

    private initializeState(): void {
        const page: MPageProps = {locked: false};

        const data: NoticeHeader = {
            id: 0,
            odinId: '',
            safeDigId: -1,
            parentId: -1,
            requestedDate: new Date(),
            l2Id: undefined,
            project: -1
        };

        const validationSchema: any = Yup.object().shape({
            odinId: EditNoticeValidator.odinId,
            requestedDate: EditNoticeValidator.requestedDate,
            requestor: EditNoticeValidator.requestor,
            l2id: EditNoticeValidator.l2id,
            project: EditNoticeValidator.project
        });

        this.state = {
            page: page,
            pageTitle: 'Edit Notice',
            pageSubTitle: '',
            form: {
                isSubmitting: false,
                id: 'EditNoticeForm',
                notice: data,
                audit: [],
                validationSchema: validationSchema,
                subNotices: [],
                noticeDetails: []
            },
            projectList: []
        };
    }

    public componentDidMount(): void {
    }

    private isFormDisabled(): boolean {
        return this.state.form.isSubmitting;
    }

    private isNoticingTeamMember(): boolean {
        const roles = this.props.msalContext.accounts[0].idTokenClaims!.roles;
        return roles?.includes(Roles.Noticing) ?? false;
    }

    private isEditDisabled(): boolean {
        //data can only be edited by noticing team members or if the status is 1 (More info required)
        return (!this.isNoticingTeamMember())
            || this.isFormDisabled();
    }

    private isPermitUpdateDisabled(): boolean {
        return !this.isNoticingTeamMember() || this.isFormDisabled();
    }

    private isSendDisabled(): boolean {
        return !this.isComplete();
    }

    private isComplete(): boolean{
        return this.state.form.subNotices.filter(sn => sn.detail!.noticeStatus !== 4).length === 0;
    }

    /** */
    private async close_Click(): Promise<void> {
        this.props.navigate('/notices');
    }

    private async goto_Click(): Promise<void> {
        const noticeId = this.state.form.notice.parentId;
        this.props.navigate(`/notices/${noticeId}`);
        window.location.reload();
    }

    private async send_Click() : Promise<void> {
        let preFill: string[] = [];

        for(const subJob of this.state.form.subNotices) {
            if(subJob.detail!.subResource !== null && subJob.detail!.subResource !== undefined && subJob.detail!.subResource !== -1) {
                const contactResult = await this.m_contactClient.callWithReply(
                    ContactReply,
                    (client) => client.contactData(subJob.detail!.subResource)
                )
                contactResult.throwIfFailed();
                preFill.push(contactResult.reply?.contact?.contactEmail ?? "");
            }
        }

        this.m_jobSendRef.current!.show(this.state.form.notice.odinId, preFill);
    }

    private toSafeDig_Click(): void {
        this.props.navigate(`/safedigs/${this.state.form.notice.safeDigId}`);
    }

    private async jobSendDialog_onClose(emailAddresses: string[]) {
        const userName = this.props.msalContext.accounts[0].name;

        const sendResult = await this.m_noticeClient.callWithReply(
            UpdateSafeDigReply,
            (client) => client.sendFiles(new SafeDigSendRequest({
                safeDigId: this.state.form.notice.id,
                emailAddresses: emailAddresses,
                user: userName
            })));

        sendResult.throwIfFailed();

        await this.page_onLoadData();
    }

    private async fileStatusDialog_Close(fileType: number, result: FileStatusResult) {
        const userName = this.props.msalContext.accounts[0].name;

        if(result === FileStatusResult.Archive) {
            const changeRequest = new ChangeFileStateRequest({
                safeDigsId: this.state.form.notice.id,
                fileType: fileType,
                fileArea: 1,
                oldStatus: 2,
                newStatus: 3,
                user: userName
            });

            const result = await this.m_fileClient.callWithReply(
                UpdateSafeDigFileReply,
                (client) => client.changeFileState(changeRequest));

            result.throwIfFailed();

            await this.page_onLoadData();
        } else if(result === FileStatusResult.Download) {
            const result = await this.m_fileClient.callWithReply(
                UpdateSafeDigFileReply,
                (client) => client.download(this.state.form.notice.id, fileType,1));

            result.throwIfFailed();
        }
    }

    private subNoticeNavigate(id: number, newEntry: boolean): void {
        if(newEntry) {
            this.props.navigate(`/notices/create/1/${this.state.form.noticeDetails[0]?.id ?? 0}/${this.state.form.subNotices.length}`);
        } else {
            this.props.navigate(`/notices/${id}`);
            window.location.reload();
        }
    }

    private async page_onLoadData(): Promise<void> {
        const headerId = Number(this.props.match.params.id);

        //Pull notice data
        const result = await this.m_noticeClient.callWithReply(
            NoticeHeaderReply, (client) => client.noticeHeader(headerId));
        result.throwIfFailed();

        const detailList = await this.m_noticeClient.callWithReply(
            NoticeDetailListReply, (client) => client.listNoticeDetails(headerId));
        detailList.throwIfFailed();

        //Read audit data
        const auditResult = await this.m_auditlogClient.callWithReply(
            AuditLogListReply, (client) => client.getDigAudit(headerId, 1));
        auditResult.throwIfFailed();

        this.safeSetState((draft: State) => {
            draft.form.audit = auditResult.reply!.data!.map((w: AuditLog) => {
                return {data: w} as AuditLogRow;
            });
        });

        //Read Project list
        const projectResult = await this.m_safedigClient.callWithReply(
            ProjectReply, (client) => client.getProjects());
        projectResult.throwIfFailed();

        const listRows = projectResult.reply!.data.map(project => ({
            value: project.id,
            label: project.name
        }));

        //Read sub notices
        const subNotices = await this.m_noticeClient.callWithReply(
            NoticeReplyMulti, (client) => client.listSubNotices(headerId));
        subNotices.throwIfFailed();
        
        if(result.reply!.noticeHeader !== null) {
            this.safeSetState(draft => {
                draft.form.notice = result.reply!.noticeHeader!;
                draft.projectList = listRows;
                draft.form.subNotices = subNotices.reply!.notices;
                draft.form.noticeDetails = detailList.reply!.noticeDetails;
            });
        }
    }

    private form_onBeforeSubmit(fieldValues: NoticeHeader, formikHelpers: FormikHelpers<NoticeHeader>): boolean {
        this.safeSetState(draft => draft.form.isSubmitting = true);
        return false;
    }

    private async form_onSubmit(fieldValues: NoticeHeader, formikHelpers: FormikHelpers<NoticeHeader>): Promise<void> {
        const updateData = new NoticeUpdateHeaderDto({
            id: fieldValues.id,
            odinId: fieldValues.odinId,
            project: fieldValues.project,
            l2Id: fieldValues.l2Id
        });

        const result = await this.m_noticeClient.callWithReply(NoticeReply, (client => client.updateHeader(updateData)));

        result.throwIfFailed()
    }

    private async form_onAfterSubmit(outcome: MFormOutcome, fieldValues: NoticeHeader, formikHelpers: FormikHelpers<NoticeHeader>, exception: any | undefined): Promise<void> {
        if(outcome === 'success') {
            this.m_pageRef.current!.messageBar.success(`Save complete.`);
        }
        this.safeSetState(draft => draft.form.isSubmitting = false);

        await this.page_onLoadData();
    }

    private form_onError(exception: any): boolean
    {
        const handled = false;
        this.m_pageRef.current!.messageBar.error(toErrorMessage(exception));
        return handled;
    }

    private getToolbarTemplate(): ReactElement<MToolbar> {
        return (
            <MToolbar>
                <MButton label="Save"
                         formId={this.state.form.id}
                         type="submit"
                         color="success"
                         icon={MSaveIconName}
                         iconOnly={false}
                         isBusy={this.isFormDisabled}
                         disabled={this.isFormDisabled}/>
                <MSpacer/>
                <MButton label="Close"
                         icon={MCloseIconName}
                         disabled={this.isFormDisabled}
                         onClick={this.close_Click}/>
                <MSpacer/>
                {(this.state.form.notice.safeDigId === -1) && <React.Fragment>
                    <MButton label="Send"
                             icon={SendIconName}
                             iconOnly={false}
                             disabled={this.isSendDisabled}
                             onClick={this.send_Click}/>
                    <MSpacer/>
                </React.Fragment>}
                {(this.state.form.notice.parentId !== -1) && <React.Fragment>
                    <MButton label="Parent"
                             icon={GotoIconName}
                             iconOnly={false}
                             disabled={false}
                             onClick={this.goto_Click}/>
                    <MSpacer/>
                </React.Fragment>}
                {this.state.form.notice.safeDigId > -1 &&
                    <React.Fragment>
                        <MButton label="Safe Dig"
                                 icon={GotoIconName}
                                 disabled={false}
                                 onClick={this.toSafeDig_Click}
                        />
                    </React.Fragment>}
            </MToolbar>
        );

    }

    public render(): ReactElement {
        const roles = this.props.msalContext.accounts[0].idTokenClaims!.roles;
        const hasNoticingRole = roles?.includes(Roles.Noticing) ?? false;

        return (
          <MPage title={this.state.pageTitle}
                 subtitle={this.state.pageSubTitle}
                 locked={this.state.page.locked}
                 width={8}
                 toolbar={this.getToolbarTemplate()}
                 onLoadData={this.page_onLoadData}
                 ref={this.m_pageRef}>

              <MForm formId={this.state.form.id}
                     initialValues={this.state.form.notice}
                     validationSchema={this.state.form.validationSchema}
                     onBeforeSubmit={this.form_onBeforeSubmit}
                     onSubmit={this.form_onSubmit}
                     onAfterSubmit={this.form_onAfterSubmit}
                     onError={this.form_onError}>

                  <NoticeFileDialog ref={this.m_fileUploadRef}
                                    jobComplete={false}
                                    uploadPermission={hasNoticingRole}
                  />
                  <FileStatusDialog ref={this.m_fileStatusRef}
                                    onDialogClose={this.fileStatusDialog_Close}
                                    jobComplete={false}
                  />
                  <JobSendDialog ref={this.m_jobSendRef} onDialogClose={this.jobSendDialog_onClose}/>

                  <div className="formgrid grid">
                      <div className="col-12">

                          <MFormSection title="General">
                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label="ID"
                                                     fieldName="odinId">
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MTextBox id={fieldProps.field.name}
                                                        maxLength={NoticeHeader.OdinIdMaxLength}
                                                        fieldProps={fieldProps}
                                                        disabled={this.isFormDisabled}
                                                        className={fieldClasses}/>
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label={'Project'}
                                                     fieldName={'project'}>
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MDropDown<number> id={fieldProps.field.name}
                                                                 disabled={false}
                                                                 fieldProps={fieldProps}
                                                                 items={this.state.projectList}
                                              />
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label="L2 ID"
                                                     fieldName="l2Id">
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MTextBox id={fieldProps.field.name}
                                                        maxLength={NoticeHeader.L2IdMaxLength}
                                                        fieldProps={fieldProps}
                                                        disabled={this.isFormDisabled}
                                                        className={fieldClasses}/>
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label="Date Requested"
                                                     fieldName="requestedDate">

                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                          return (
                                              <MCalendar id={fieldProps.field.name}
                                                         fieldProps={fieldProps}
                                                         disabled={true}
                                                         className={fieldClasses}
                                                         initialValue={fieldProps.field.value}
                                              />
                                          );

                                      }}

                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label="Requested By"
                                                     fieldName="requestor">

                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                          return (
                                              <MTextBox id={fieldProps.field.name}
                                                        maxLength={NoticeHeader.RequestorMaxLength}
                                                        readonly={false}
                                                        fieldProps={fieldProps}
                                                        disabled={true}
                                                        className={fieldClasses}/>
                                          );

                                      }}

                                  </MFormFieldControl>
                              </div>
                          </MFormSection>

                          <Divider/>
                          <FormSection title="Details">
                              <div className="min-w-full">
                                  <NoticeDetailListControl
                                      noticeId={this.state.form.notice.id}
                                      rowData={this.state.form.noticeDetails}
                                      history={this.props.history}
                                      navigate={this.props.navigate}
                                      match={this.props.match}
                                      location={this.props.location}
                                  />
                              </div>
                          </FormSection>

                          {this.state.form.notice.parentId === -1 && <div>
                              <Divider/>
                              <FormSection title={"Additional works"}>
                                  <div className="min-w-full">
                                      <SubNoticeControl
                                          rowData={this.state.form.subNotices}
                                          navigateTo={this.subNoticeNavigate}
                                      />
                                  </div>
                              </FormSection>
                          </div>}

                          <Divider/>
                          <MFormSection title="History">

                              <div className="min-w-full">
                                  <AuditListControl rowData={this.state.form.audit}/>
                              </div>
                          </MFormSection>

                      </div>
                  </div>
              </MForm>

          </MPage>
        );
    }
}

export default withMsal(WithRouter(EditNoticePage));